import { render, staticRenderFns } from "./ClientContactsFilter.vue?vue&type=template&id=b1da6464&scoped=true&"
import script from "./ClientContactsFilter.vue?vue&type=script&lang=js&"
export * from "./ClientContactsFilter.vue?vue&type=script&lang=js&"
import style0 from "./ClientContactsFilter.vue?vue&type=style&index=0&id=b1da6464&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1da6464",
  null
  
)

export default component.exports